import React, { createContext, useState } from "react";

const NotificationsContext = createContext();

export const NotificationsProvider = ({ children }) => {
  const [notifications, setNotifications] = useState({
    productUpdates: [],
    notificationArray: [],
    productUpdatesFetchedForClient: null,
    notificationsFetchedForClient: null,
  });

  return (
    <NotificationsContext.Provider value={{ notifications, setNotifications }}>
      {children}
    </NotificationsContext.Provider>
  );
};

export default NotificationsContext;
